export const PRICING_LIST_PDF = require("./LuxTechPricingList.pdf");